/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotEqualResourceId: core.serialization.ObjectSchema<
    serializers.NotEqualResourceId.Raw,
    Truvity.NotEqualResourceId
> = core.serialization.object({
    value: core.serialization.string(),
});

export declare namespace NotEqualResourceId {
    export interface Raw {
        value: string;
    }
}
